/**
 * Deep-link plumbing for the per-source "mode" (LiPostType, FundingMaType, ...).
 *
 * When a sub-type catalog tile is picked, `useCreateListFromTile` appends the chosen
 * mode to the source-step URL as `?mode=<MODE>`. Each source form then pre-selects that
 * mode for a brand-new source via `resolveSourceMode`. `resolveSourceMode` is a plain
 * function (not a hook) so it can be called inline inside a form's existing default/reset
 * expression without growing the file — several forms are already at the 500-line cap.
 */

export const SOURCE_MODE_PARAM = "mode";

/**
 * Returns the deep-linked mode from the current URL, but only when it is one of the
 * form's allowed modes; otherwise returns `fallback`. Keeps each source form defaulting
 * to its normal mode when the param is absent or belongs to a different source type.
 */
export const resolveSourceMode = <T extends string>(allowed: readonly T[], fallback: T): T => {
	const raw = new URLSearchParams(window.location.search).get(SOURCE_MODE_PARAM);

	return raw && (allowed as readonly string[]).includes(raw) ? (raw as T) : fallback;
};
